import { TimeSeriesEntry } from 'types/metrics';

export const nonPredictionMetricKeys = [
  'req',
  'rec',
  'max',
  'p75',
  'p50',
  'min',
  'avgStall',
] as const;

export const nonPredictionMemoryMetricKeys = nonPredictionMetricKeys.filter(
  (k) => k !== 'avgStall'
);

export const predictionMetricKeys = [
  'rec',
  'recPredicted',
  'avg',
  'avgPredicted',
] as const;

export type CpuHistoricalMetricKey = (typeof nonPredictionMetricKeys)[number];
export type CpuPredictionMetricKey = (typeof predictionMetricKeys)[number];

export type ResourceMetricKey = CpuHistoricalMetricKey | CpuPredictionMetricKey;

export type CpuChartDataPoint = { timestamp: string } & Record<
  CpuHistoricalMetricKey,
  number | null
>;

export type CpuPredictionDataPoint = { timestamp: string } & Record<
  CpuPredictionMetricKey,
  number | null
>;

export type MemoryChartDataPoint = { timestamp: string } & Record<
  Exclude<CpuHistoricalMetricKey, 'avgStall'>,
  number | null
>;

export const jvmMetricKeys = [
  'heapCommitted',
  'heapRecommended',
  'heapUsed',
] as const;

export type JvmMetricKey = (typeof jvmMetricKeys)[number];

export type JvmChartDataPoint = TimeSeriesEntry<{
  heapUsed: number | null;
  heapCommitted: number | null;
  heapRecommended: number | null;
}>;
